import {
  Organization,
  PaginatedResponse,
  CreateOrganizationRequest,
  UpdateOrganizationRequest,
} from '../types';
import apiService from './api';

export class OrganizationService {
  async getAllOrganizations(
    page: number = 0,
    size: number = 10,
    sort?: string,
    filters?: any
  ): Promise<PaginatedResponse<Organization>> {
    return apiService.getPaginated<Organization>('/api/organizations', page, size, sort, filters);
  }

  async getOrganizationById(id: string): Promise<Organization> {
    return apiService.get<Organization>(`/api/organizations/${id}`);
  }

  async createOrganization(organizationData: CreateOrganizationRequest): Promise<Organization> {
    return apiService.post<Organization>('/api/organizations', organizationData);
  }

  async updateOrganization(
    id: string,
    organizationData: UpdateOrganizationRequest
  ): Promise<Organization> {
    return apiService.put<Organization>(`/api/organizations/${id}`, organizationData);
  }

  async deleteOrganization(id: string): Promise<void> {
    await apiService.delete(`/api/organizations/${id}`);
  }

  async getOrganizationStats(id: string): Promise<any> {
    return apiService.get(`/api/organizations/${id}/stats`);
  }
}

export const organizationService = new OrganizationService();
export default organizationService;
